import { createFileRoute } from '@tanstack/react-router';

// relative imports
import AddSourcesPage from '../../../../../../components/source-management/add-sources-page/AddSourcesPage';
import LoadingPage from '../../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/sources/add',
)({
  component: AddSourcesPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    configPageId: 'crypto-sources',
    isClientRoute: true,
    meta: {
      title: 'Client Add Source | Ledgible',
    },
  },
});
